import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import userSelectors from "../../ducks/user/selectors";

function AuthenticatedRoute(props) {
  let isAuthenticated: boolean = useSelector(userSelectors.getToken);
  let { ...routeProps } = props;

  if (typeof isAuthenticated === "undefined") {
    return null;
  } else if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else {
    return <Route {...routeProps} />;
  }
}

export default AuthenticatedRoute;
